import axiosInstance from '@/lib/axiosInstance';
import { supabase } from '@/lib/supabase';
import { AxiosPromise } from 'axios';
import {
  CreateWorkspaceParams,
  CreateWorkspaceResponse,
  DeleteWorkspaceParams,
  UpdateWorkspaceParams,
} from './type';
import { WORKSPACE_STATUS } from './constants';

export const getWorkspaces = async () => {
  const { data, error } = await supabase
    .from('workspace')
    .select()
    .in('workspace_status', [
      WORKSPACE_STATUS.DEFAULT,
      WORKSPACE_STATUS.NORMAL,
    ]);
  if (error) throw error;
  return data?.sort((a, b) => a.id - b.id);
};

export const getWorkspaceById = async (id: string) => {
  const { data, error } = await supabase
    .from('workspace')
    .select()
    .eq('workspace_id', id)
    .single();
  if (error) throw error;
  return data;
};

export const updateWorkspaceById = async ({
  id,
  data: params,
}: UpdateWorkspaceParams) => {
  const { data, error } = await supabase
    .from('workspace')
    .update(params)
    .eq('workspace_id', id);
  if (error) throw error;
  return data;
};

export const createWorkspaceInit = (): AxiosPromise<any> => {
  return axiosInstance.post('/workspace/init');
};

export const createWorkspace = async (data: CreateWorkspaceParams) => {
  const result = await axiosInstance.post<CreateWorkspaceResponse>(
    '/workspace/new',
    data
  );
  return result?.data;
};

export const deleteWorkspace = (
  params: DeleteWorkspaceParams
): AxiosPromise<any> => {
  return axiosInstance.post('/workspace/delete', params);
};
